<template>
  <b-btn :variant=variant :size=size target='_blank' :href='href' @click='$emit("click")' class='m-2'>
    {{label}}
  </b-btn>
</template>

<script>
export default {
  props: {
    href: { type: String },
    label: { type: String, default: '???' },
    variant: { type: String, default: 'outline-info' },
    size: { type: String, default: 'sm' }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/utility/ExternalButton.vue